import { AxiosError } from "axios"
import { shallowEqual } from "react-redux"
import { Action } from "redux"
import { createSelectorCreator, defaultMemoize } from "reselect"
import { Locales } from "i18n/config"
import * as notifications from "./notifications/notifications.actions"

export const createShallowEqualSelector = createSelectorCreator(defaultMemoize, shallowEqual)

interface ServerErrorMessageParams {
  service?: string
  endpoint?: string
  error: AxiosError
}

export const notifyIfServerError = ({ service, endpoint, error }: ServerErrorMessageParams): Action =>
  notifications.show({
    id: JSON.stringify(error),
    message: generateServerErrorMessage({ service, endpoint, error }),
    variant: "error",
  })

export const generateServerErrorMessage = ({ service, endpoint, error }: ServerErrorMessageParams): string => {
  const status = error.response && error.response.status
  if (!status) {
    return "error.server.500"
  }
  const data = error.response?.data as { message?: string }
  if (status === 400 && data?.message) {
    return data.message
  }
  if (!service || !endpoint) {
    return `error.server.${status}`
  }
  if (service && endpoint) {
    return `error.${service}.${endpoint}.${status}`
  }
  return error.message
}

export const setDocumentLanguage = (lang: Locales) => {
  document.documentElement.lang = lang
}

export const setDocumentTitle = (practiceName: string) => {
  document.title = `Docket - ${practiceName}`
}
